export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-image-text/_content-section-image-text.twig";